import Icon from '../components/Icon.vue'

Icon.register({
  thumbtack: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M298 214.3c48 22.3 86 62.6 86 113.7 0 13.3-10.7 24-24 24h-136v104c0 1-0.4 2.6-0.8 3.6l-24 48c-2.9 5.9-11.4 5.9-14.3 0l-24-48c-0.6-1.1-0.8-2.3-0.8-3.6v-104h-136c-13.3 0-24-10.7-24-24 0-50.7 37.5-91.2 86-113.7l12.2-118.3h-42.2c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-42.2z'
      }
    ]
  }
})
